import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from './../types/dashboardTypes';

export const getPowerBIData = (dashboardType: any, onCallback: any = (): any => { }): Action<any> =>
  updateAction(actionTypes.DASHBOARD_FILTER_REQUESTED, {dashboardType, onCallback});

export const submitDashboardFilterSuccess = (payload: any): Action<any[]> => ({
  type: actionTypes.DASHBOARD_FILTER_SUCCESS, ...{payload},
});

export const setMetricsFilterFilter = (metricsBoardFilter: any, dashboardType: string): Action<any> =>
  updateAction(actionTypes.SET_METRICS_BOARD_FILTER, {metricsBoardFilter, dashboardType});

export const setMetricsPayers = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_METRICS_BOARD_PAYER, payload);

export const downloadMetricsBoardPDF = (payload: any): Action<any> =>
  updateAction(actionTypes.DOWNLOAD_METRICS_BOARD_PDF_REQUESTED, payload);

export const setIsDownloadMetricsBoardPDF = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_DOWNLOAD_METRICS_BOARD_PDF, payload);
